import { Card, Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { AuthenticationInstance } from "../utils/authenticationClass";
import { BusinessInstance } from "../utils/businessClass";
// import 'bootstrap/dist/css/bootstrap.min.css';

export const BusinessSelection = () => {
  const dispatch = useDispatch();
  const { businesses } = useSelector((state: any) => state.business);

  const handleSelectBusiness = async (business: any) => {
    console.log(business);
    await BusinessInstance.setBusiness(business);
  };

  const handleLogout = async () => {
    await AuthenticationInstance.handleSignOut();
  };

  return (
    <div
      style={{
        background: "#242424",
        flex: 1,
        height: "100vh",
        display: "flex",
      }}
    >
      <Container>
        <h2 onClick={handleLogout} className="text-white text-center my-4">
          Select Your Business
        </h2>
        <Row xs={3} md={6} className="g-4">
          {businesses.map((business: any, idx: number) => (
            <Col key={idx}>
              <Card
                style={{
                  cursor: "pointer",
                }}
                onClick={() => handleSelectBusiness(business)}
                className="h-100"
              >
                <Card.Img variant="top" src={business[business.businessType].avatarUrl} />
                <Card.Body>
                  <Card.Title>{business[business.businessType].name}</Card.Title>
                  {business.businessType === "venue" && (
                    <Card.Text>{business[business.businessType].address}</Card.Text>
                  )}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};
